import React from 'react';
import { Link } from 'react-router-dom'; // import Link
import './Footer.css';

const Footer = () => {
  const footerLinks = {
    Markets: [
      { name: 'Stocks', path: '/article/tech-stocks-lead-market-gains' },
      { name: 'Bonds', path: '/article/treasury-yields-higher' },
      { name: 'Currencies', path: '/article/dollar-strengthens' },
      { name: 'Commodities', path: '/article/oil-prices-fluctuate' },
      { name: 'Crypto', path: '/article/bitcoin-holds-100k' },
      { name: 'ETFs', path: '/markets/etfs' },
    ],
    Technology: [
      { name: 'AI', path: '/article/ai-revolution-transforms-industries' },
      { name: 'Cybersecurity', path: '/article/cybersecurity-threats-emerge' },
      { name: 'Startups', path: '/article/electric-vehicle-sales-surge' },
      { name: 'Innovation', path: '/article/quantum-computing-breakthrough' },
      { name: 'Space', path: '/article/renewable-energy-investment-high' },
    ],
    Politics: [
      { name: 'US Politics', path: '/article/us-futures-bank-earnings' },
      { name: 'Asia Politics', path: '/latest-news/china-vanke-fallout-smaller-builder-state-support' },
      { name: 'Europe', path: 'article/european-markets-gains' },
      { name: 'Middle East', path: '/latest-news/ab-inbev-stake-container-plants' },
      { name: 'UK', path: '/article/trump-oil-empire' },
    ],
    More: [
      { name: 'Businessweek', path: '/businessweek' },
      { name: 'Opinion', path: '/opinion' },
      { name: 'Wealth', path: '/wealth' },
      { name: 'Pursuits', path: '/pursuits' },
      { name: 'CityLab', path: '/citylab' },
    ],
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div className="footer-col" key={category}>
              <h3>{category}</h3>
              <ul>
                {links.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>&copy; RedboxGlobal  All Rights Reserved.</p>
          <div className="footer-links">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookie Settings</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/help">Help</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

